const isResizeObserverLoop = (value) =>
  String(value || "").includes("ResizeObserver loop");

function hideDevOverlay() {
  document
    .querySelectorAll(
      "#webpack-dev-server-client-overlay, iframe#webpack-dev-server-client-overlay"
    )
    .forEach((node) => node.remove());
}

function patchResizeObserver() {
  const NativeRO = window.ResizeObserver;
  if (!NativeRO || NativeRO.__zubrusPatched) return;

  class SafeResizeObserver extends NativeRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (typeof callback === "function") callback(entries, observer);
        });
      });
    }
  }

  SafeResizeObserver.__zubrusPatched = true;
  window.ResizeObserver = SafeResizeObserver;
}

export function suppressResizeObserverError() {
  patchResizeObserver();

  window.addEventListener(
    "error",
    (event) => {
      if (!isResizeObserverLoop(event?.message || event?.error?.message)) return;
      event.stopImmediatePropagation();
      event.preventDefault();
      hideDevOverlay();
    },
    true
  );

  const observer = new MutationObserver(() => {
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (!overlay) return;
    let text = overlay.innerText || "";
    try {
      text = overlay.contentDocument?.body?.innerText || text;
    } catch {
      // overlay iframe may be inaccessible
    }
    if (isResizeObserverLoop(text)) hideDevOverlay();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
